module.exports = __webpack_public_path__ + "static/media/FREEDOM60-logo.08c44c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FREEDOM60-logo.png
// module id = 246
// module chunks = 0